import type { WithdrawalOnlyServiceName } from '@/helpers/enums';

type WithdrawalServiceBranding = {
  logoSrc: string;
};

const logoBaseUrl =
  'https://d2bfhuxozzsc0y.cloudfront.net/InfinitWebPortal/medias/header';

export const withdrawalBranding = {
  gymobile: {
    logoSrc: `${logoBaseUrl}/logo_gymobile.png`,
  },
  happystream: {
    logoSrc: `${logoBaseUrl}/HS_BW_LOGO.png`,
  },
  infinitgame: {
    logoSrc: `${logoBaseUrl}/Header_IG.png`,
  },
  mygymtrainer: {
    logoSrc: `${logoBaseUrl}/logo_mygymtrainer.png`,
  },
  mystreaming: {
    logoSrc: `${logoBaseUrl}/mystreaming_ro_logo.png`,
  },
  newgamz: {
    logoSrc: `${logoBaseUrl}/newgamz_ro_logo.png`,
  },
} satisfies Record<WithdrawalOnlyServiceName, WithdrawalServiceBranding>;
